import type { TDevice } from '../definitions'

import isIOS      from './isIOS'
import isTablet   from './isTablet'
import isMobile   from './isMobile'
import isAndroid  from './isAndroid'
import isHandheld from './isHandheld'

/**
 * Device típusának elkérése.
 * @param ua - UserAgent.
 */
export default function getDevice (ua: string): TDevice {
  if (isAndroid(ua)) {
    return 'Android'
  }

  if (isIOS(ua)) {
    return 'iOS'
  }

  if (isTablet(ua)) {
    return 'Tablet'
  }

  if (isMobile(ua)) {
    return 'Mobile'
  }

  if (isHandheld(ua)) {
    return 'Handheld'
  }

  return 'PC'
}
